<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData)" style="padding: 1rem 1rem 1rem 1rem">
	<div
		fxLayout="row"
		fxLayoutAlign="{{ isCarrierLoggedIn ? 'center start' : 'start start' }}"
		fxLayoutGap="1rem"
	>
		<div
			*ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane)"
			fxFlex="70"
			class="content_container overflow_scroll"
		>
			<div *ngIf="!isCarrierLoggedIn" fxLayout="row">
				<div fxFlex>
					<div fxLayout="row">
						<div fxFlex fxLayoutAlign="start center">
							<b *ngIf="carrierLaneData.lane.customerCarrier" class="font-size-20 primary-text">
								{{ carrierLaneData.lane.businessName }}
							</b>
							<span *ngIf="!carrierLaneData.lane.customerCarrier" class="font-size-16">
								{{ carrierLaneData.lane.businessName }}
							</span>

							<div
								*ngIf="
									SHOW_IN_NETWORK_LOGO(
										CARRIER_QUALITY_ENABLED,
										openedMatch?.firmDot,
										isCarrierVettingIntegrationEnabled,
										openedMatch?.vettingSource,
										openedMatch?.vettingSourceId,
										carrierVettingService,
										carrierLaneData.lane.carrierId,
										carrierLaneData.lane.customerCarrier
									)
								"
								fxLayoutAlign="start center"
							>
								<img
									class="h-18 in_network_logo"
									[src]="carrierVettingService.logo(openedMatch?.vettingSource)"
								/>
								<img
									*ngIf="openedMatch?.haulPayApproved && environment.SHOW_QUALITY"
									class="h-18 in_network_logo"
									[src]="haulpayService.logo()"
									[matTooltip]="haulpayService.tooltip()"
								/>
								<span class="m-l-1 m-t-0-5 font-size-13 primary-text">
									{{
										carrierVettingService.tooltip(
											openedMatch?.vettingSource,
											openedMatch?.carrierOnboardedOn,
											openedMatch?.lastVettingTime
										)
									}}
								</span>
							</div>

							<span
								(click)="onboardCarrier()"
								*ngIf="
									isIntegrationLinkAvailable &&
									SHOW_ONBOARD_CARRIER_LINK(
										CARRIER_QUALITY_ENABLED,
										carrierVettingService,
										openedMatch?.vettingSource,
										carrierLaneData.lane.customerCarrier,
										openedMatch?.firmDot,
										isCarrierVettingIntegrationEnabled,
										openedMatch?.vettingSourceId,
										carrierVettingService.isCarrierOnboarded(carrierLaneData.lane.carrierId)
									)
								"
								class="link ml-6 font-size-12"
							>
								Onboard Carrier
							</span>

							<span class="ml-6" *ngIf="isBaEnabled && isBookNowEnabled">
								<button
									mat-button
									mat-raised-button
									color="primary"
									*ngIf="showAddCarrierToBookNowConfigButton"
									(click)="updateBookNowData(true)"
								>
									Allow Book Now
								</button>
								<button
									mat-button
									mat-raised-button
									color="primary"
									*ngIf="showRemoveCarrierFromBookNowConfigButton"
									(click)="updateBookNowData(false)"
								>
									Remove Book Now
								</button>
							</span>
						</div>
						<div *ngIf="productsService.ASSIGN_CARRIERS" fxFlex="20" fxLayoutAlign="end center">
							<app-user-selector
								(userChanged)="setAssignee($event)"
								[selectedUsers]="
									IS_NULL_OR_UNDEFINED(userCarrierMap) ? [] : [userCarrierMap.assigneeId]
								"
								[showAssignMe]="false"
								[singleselect]="true"
								customCssClass="remove_form_field_margin"
								floatLabel="never"
								placeholder="Assign Rep"
							></app-user-selector>
						</div>
					</div>

					<div *ngIf="carrierLaneData.lane.customerCode" fxLayout="row">
						<span class="font-size-14">
							Code: {{ carrierLaneData.lane.customerCode || '--' }}
							<mat-icon
								(click)="
									$event.stopPropagation();
									utilService.copyToClipboard(
										carrierLaneData.lane.customerCode,
										COPY_TO_CLIPBOARD_MSGS.CUSTOMER_CODE
									)
								"
								*ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane.customerCode)"
								[inline]="true"
								class="copy-icon primary-text"
								>file_copy
							</mat-icon>
						</span>
					</div>

					<div fxLayout="row">
						<div fxFlex>
							<span class="font-size-14">
								<span>HQ: </span>
								<span *ngIf="IS_NOT_EMPTY(carrierLaneData.lane.carrierHQ)">
									{{ carrierLaneData.lane.carrierHQ }}
								</span>
								<span *ngIf="!IS_NOT_EMPTY(carrierLaneData.lane.carrierHQ)">--</span>
							</span>
						</div>
						<div fxFlex>
							<span class="font-size-14">
								<span>MC #: </span>
								<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane.firmMc)">
									{{ carrierLaneData.lane.firmMc }}
								</span>
								<span *ngIf="IS_NULL_OR_UNDEFINED(carrierLaneData.lane.firmMc)"> -- </span>
							</span>
						</div>
						<div fxFlex>
							<span class="font-size-14">
								<span>DOT #: </span>
								<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane.firmDot)">
									{{ carrierLaneData.lane.firmDot }}
								</span>
								<span *ngIf="IS_NULL_OR_UNDEFINED(carrierLaneData.lane.firmDot)"> -- </span>
							</span>
						</div>
					</div>

					<div fxLayout="row">
						<div fxFlex>
							<span class="font-size-14">
								<span>Trucks: </span>
								<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane.powerUnits)">{{
									carrierLaneData.lane.powerUnits
								}}</span>
								<span *ngIf="IS_NULL_OR_UNDEFINED(carrierLaneData.lane.powerUnits)">--</span>
							</span>
						</div>
						<div fxFlex>
							<span class="font-size-14"> Trailers: </span>
							<span>{{ carrierLaneData?.lane?.trailers || '--' }}</span>
						</div>
						<div fxFlex>
							<span class="font-size-14">
								<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane.drivers)"
									>Drivers:
								</span>
								<span>{{ carrierLaneData.lane.drivers }}</span>
								<span *ngIf="IS_NULL_OR_UNDEFINED(carrierLaneData.lane.drivers)">--</span>
							</span>
						</div>
					</div>

					<div fxLayout="row">
						<div *ngIf="IS_HAZMAT_ENABLED" fxFlex>
							<span class="font-size-14">
								<span>Hazmat: </span>
								<span>{{ carrierLaneData.lane.hazmat ? 'Yes' : 'No' }}</span>
							</span>
						</div>
						<div *ngIf="IS_TEAMS_CAPACITY_ENABLED" fxFlex>
							<span class="font-size-14">
								<span>Has Teams: </span>
								<span>
									{{
										carrierLaneData.lane.hasTeams &&
										IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane.hasTeamsUpdatedOn)
											? 'Yes'
											: 'No'
									}}
								</span>
							</span>
						</div>
						<div fxFlex>
							<span class="font-size-14">
								<span>Active: </span>
								<span>{{ carrierLaneData.lane.active ? 'Yes' : 'No' }}</span>
							</span>
						</div>
					</div>

					<div fxLayout="row">
						<div fxFlex>
							<span class="font-size-14">
								<span>Contact: </span>
								<span
									*ngIf="IS_NOT_EMPTY(carrierLaneData.lane.representative1)"
									class="capitalize"
								>
									{{ carrierLaneData.lane.representative1?.toLowerCase() }}
								</span>
								<span *ngIf="!IS_NOT_EMPTY(carrierLaneData.lane.representative1)">--</span>
							</span>
						</div>
						<div fxFlex>
							<span class="font-size-14">
								<span>Phone: </span>
								<a
									*ngIf="IS_NOT_EMPTY(carrierLaneData.lane.phone)"
									href="tel:{{ carrierLaneData.lane.phone }}"
								>
									{{ carrierLaneData.lane.phone }}
								</a>
								<span *ngIf="!IS_NOT_EMPTY(carrierLaneData.lane.phone)">--</span>
							</span>
						</div>
						<div fxFlex>
							<span class="font-size-14">
								<span>Cell: </span>
								<a
									*ngIf="IS_NOT_EMPTY(carrierLaneData.lane.cellPhone)"
									href="tel:{{ carrierLaneData.lane.cellPhone }}"
								>
									{{ carrierLaneData.lane.cellPhone }}
								</a>
								<span *ngIf="!IS_NOT_EMPTY(carrierLaneData.lane.cellPhone)">--</span>
							</span>
						</div>
					</div>

					<div fxLayout="row">
						<div fxFlex>
							<span class="font-size-14">
								<span>Main Email: </span>
								<span
									*ngIf="IS_NOT_EMPTY(carrierLaneData.lane.businessEmailAddress)"
									class="truncate_text"
									(click)="
										utilService.copyToClipboard(
											carrierLaneData.lane.businessEmailAddress,
											COPY_TO_CLIPBOARD_MSGS.EMAIL
										)
									"
								>
									<a href="mailto:{{ carrierLaneData.lane.businessEmailAddress }}">
										{{ carrierLaneData.lane.businessEmailAddress?.toLowerCase() }}
									</a>
								</span>
								<span *ngIf="!IS_NOT_EMPTY(carrierLaneData.lane.businessEmailAddress)">--</span>
							</span>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="isCarrierLoggedIn" fxLayout="row">
				<mat-card class="p-b-0 full-width">
					<mat-card-title>
						<span class="f-s-w-500">{{ carrierLaneData.lane.businessName }}</span>
					</mat-card-title>
					<mat-divider></mat-divider>

					<mat-card-content>
						<form (keydown.enter)="$event.preventDefault()" [formGroup]="carrierDetails">
							<div class="p-0-5" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
								<div fxFlex fxLayoutAlign="center center">
									<mat-form-field fxFlex>
										<input
											autocomplete="off"
											formControlName="businessName"
											matInput
											placeholder="Enter Business Name"
											required
											type="text"
										/>
										<mat-icon class="primary-light-color" matSuffix>business</mat-icon>
									</mat-form-field>
								</div>

								<div fxFlex fxLayoutAlign="center center">
									<mat-form-field fxFlex>
										<input
											#LocationCtrl="ngModel"
											(setAddress)="getAddressOnChange($event, 'hq')"
											[(ngModel)]="carrierHQ"
											[ngModelOptions]="{ standalone: true }"
											appGoogleLocation
											matInput
											name="carrierHQ"
											placeholder="Enter Carrier HQ"
											type="text"
										/>
									</mat-form-field>
								</div>
							</div>

							<div class="p-0-5" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
								<div fxFlex fxLayoutAlign="center center">
									<mat-form-field fxFlex>
										<input
											appNumbersInput
											formControlName="dot"
											matInput
											placeholder="Enter DOT #"
											type="text"
										/>
										<mat-icon class="primary-light-color" matSuffix>local_shipping</mat-icon>
									</mat-form-field>
								</div>

								<div fxFlex fxLayoutAlign="center center">
									<mat-form-field fxFlex>
										<input
											appNumbersInput
											formControlName="mc"
											matInput
											placeholder="Enter MC #"
											type="text"
										/>
										<mat-icon class="primary-light-color" matSuffix>local_shipping</mat-icon>
									</mat-form-field>
								</div>
							</div>

							<div class="p-0-5" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
								<div fxFlex>
									<mat-form-field fxFlex>
										<input
											autocomplete="off"
											formControlName="powerUnits"
											matInput
											placeholder="Trucks"
											type="number"
										/>
										<mat-icon class="primary-light-color" matSuffix>local_shipping</mat-icon>
									</mat-form-field>
								</div>

								<div fxFlex>
									<mat-form-field fxFlex>
										<input
											autocomplete="off"
											formControlName="drivers"
											matInput
											placeholder="Drivers"
											type="number"
										/>
										<mat-icon class="primary-light-color" matSuffix>local_shipping</mat-icon>
									</mat-form-field>
								</div>

								<div fxFlex>
									<mat-form-field fxFlex>
										<input
											[showMaskTyped]="true"
											formControlName="phone"
											mask="(000) 000-0000"
											matInput
											placeholder="Phone Number"
										/>
										<mat-icon class="primary-light-color" matSuffix>contact_phone</mat-icon>
									</mat-form-field>
								</div>
							</div>
						</form>
					</mat-card-content>
					<mat-divider></mat-divider>

					<mat-card-actions>
						<div class="p-1" fxLayout="row" fxLayoutAlign="end start">
							<button
								(click)="updateCarrierDetails()"
								*ngIf="!isUpdatingCarrier"
								[disabled]="isCarrierFormDisabled()"
								color="primary"
								mat-button
								mat-raised-button
							>
								Update
							</button>
							<span class="p-8">
								<mat-spinner
									*ngIf="isUpdatingCarrier"
									[diameter]="11"
									strokeWidth="1"
								></mat-spinner>
							</span>
						</div>
					</mat-card-actions>
				</mat-card>
			</div>

			<div fxLayout="row" fxLayoutAlign="start start">
				<div fxFlex>
					<h3 class="primary-text">Representatives</h3>
				</div>
				<div *ngIf="!isCarrierLoggedIn" fxFlex fxLayoutAlign="end center">
					<button (click)="openContactDialog(null)" color="primary" mat-raised-button>
						ADD CONTACT
					</button>
				</div>
			</div>
			<div *ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane.carrierId)" fxLayout="row">
				<app-carrier-contacts
					(updateContactsList)="contactList = $event"
					[carrierId]="carrierLaneData.lane.carrierId"
					[carrier]="null"
					[contactList]="contactList"
					[editPrimaryContact]="isCarrierLoggedIn"
					[incorrectContactInfoEnabled]="incorrectContactInfoEnabled"
					[isCarrierLoggedIn]="isCarrierLoggedIn"
					[isCarrierProfile]="true"
					[isCarrierUpdate]="isCarrierLoggedIn"
					[isEditContact]="isCarrierLoggedIn"
					[lane]="carrierLaneData.lane"
					[oldCarrierId]="null"
					fxFlex="100"
				>
				</app-carrier-contacts>
			</div>

			<div fxLayout="row">
				<div fxFlex>
					<h3 class="primary-text">Lanes</h3>
				</div>
				<div *ngIf="!isCarrierLoggedIn" fxFlex fxLayoutAlign="end center">
					<button (click)="recruitLanes()" color="primary" mat-raised-button>RECRUIT LANES</button>
				</div>
				<div *ngIf="isCarrierLoggedIn" fxFlex fxLayoutAlign="end center">
					<app-add-lane
						(laneAdded)="laneAdded($event)"
						[carrierId]="carrier?.id"
						[editLane]="false"
						[fromCarrier]="IS_ACCOUNT_TYPE_CARRIER"
						[isDisabled]="false"
						[oldCarrierId]="null"
						[usePublicCreateLane]="false"
						runsReverseLaneText="Add return lane"
					>
					</app-add-lane>
				</div>
			</div>
			<div *ngIf="!isCarrierLoggedIn" fxLayout="row">
				<app-broker-lane-details
					[carrierLaneData]="carrierLaneData"
					[carrierNotesList]="
						IS_NOT_NULL_OR_UNDEFINED(notesListComponent) &&
						IS_NOT_NULL_OR_UNDEFINED(notesListComponent.carrierNotes)
							? notesListComponent.getCarrierNotesList()
							: null
					"
					[incorrectLaneFeedback]="true"
					[recentFeedbackList]="recentFeedbackList"
					(laneSelected)="updateSelectedLane($event)"
					fxFlex="100"
					[selectedLane]="selectedLane"
				></app-broker-lane-details>
			</div>

			<div *ngIf="isCarrierLoggedIn">
				<app-carrier-lanes
					(lanesListUpdated)="lanesList = $event"
					(pageNumber)="LANES_CURRENT_PAGE = $event; getCarrierLanes()"
					[carrier]="carrier"
					[carrierid]="carrierLaneData.lane.carrierId"
					[enableProjectSearch]="isCarrierLoggedIn"
					[inputConfig]="inputConfig"
					[isActions]="true"
					[lanesLength]="lanesLength"
					[lanesList]="lanesList"
					[showfrequencyColumn]="true"
				></app-carrier-lanes>
			</div>

			<mat-card *ngIf="IS_NOT_NULL_OR_UNDEFINED(lanesList) && lanesList.length == 0" class="m-t-1">
				<mat-card-content fxLayoutAlign="center center">
					<h4 class="primaryTextColor" color="primary">No data available.</h4>
				</mat-card-content>
			</mat-card>
		</div>

		<div
			*ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierLaneData.lane) && !isCarrierLoggedIn"
			fxFlex="30"
			class="tabs_container_padding_top"
		>
			<div fxLayout="row" class="tabs_container overflow_scroll" stickybits>
				<div fxLayout="column" fxFlex>
					<div
						class="overflow_visible quality_tab_container"
						*ngIf="accountSettings.CARRIER_QUALITY"
					>
						<div fxLayout="row">
							<mat-tab-group
								class="custom-tab h-100 full-width disable_tab_header_transition"
								dynamicHeight
								[@.disabled]="true"
								[ngClass]="{
									fixed_tab_header: true,
								}"
							>
								<mat-tab>
									<ng-template matTabLabel>
										<span>Quality</span>
									</ng-template>
									<div class="mlr5">
										<app-quality
											class="full-width"
											*ngIf="carrierLaneData?.lane?.carrierId"
											[carrierId]="carrierLaneData.lane.carrierId"
											[mc]="carrierLaneData.lane.firmMc"
											[dot]="carrierLaneData.lane.firmDot"
											[carrierActive]="openedMatch?.active"
											[isCarrierInNetwork]="openedMatch?.customerCarrier"
											[ccBookingRateDisplay]="openedMatch?.ccBookingRateDisplay"
											[ccEngagementRateDisplay]="openedMatch?.ccEngagementRateDisplay"
											[ccFalloffRateDisplay]="openedMatch?.ccFalloffRateDisplay"
											[ccTotalBookedLoads]="openedMatch?.ccTotalBookedLoads"
											[ccScore]="openedMatch?.ccScore"
											[vettingOverallDisplay]="carrierLaneData.lane.vettingOverallDisplay"
											[vettingAuthorityDisplay]="carrierLaneData.lane.vettingAuthorityDisplay"
											[vettingInsuranceDisplay]="carrierLaneData.lane.vettingInsuranceDisplay"
											[vettingOperationsDisplay]="carrierLaneData.lane.vettingOperationsDisplay"
											[vettingSafetyDisplay]="carrierLaneData.lane.vettingSafetyDisplay"
											[vettingOtherDisplay]="carrierLaneData.lane.vettingOtherDisplay"
											[infractionDetails]="carrierLaneData.lane.infractionDetails"
											[lastVettingTime]="openedMatch?.lastVettingTime"
										></app-quality>
										<mat-card
											*ngIf="IS_NULL_OR_UNDEFINED(carrierLaneData?.lane?.carrierId)"
											class="m-t-1 primary-text font-size-17"
											fxFlex="100"
											fxLayoutAlign="center center"
										>
											Please select a carrier to see the Quality score.
										</mat-card>
									</div>
								</mat-tab>
							</mat-tab-group>
						</div>
					</div>

					<div fxFlex class="overflow_scroll" [stickyOffset]="0" [stickyOffset]="0" stickybits>
						<div fxLayout="row">
							<mat-tab-group
								class="custom-tab h-100 h-100 full-width disable_tab_header_transition fixed_tab_header"
								dynamicHeight
								[@.disabled]="true"
							>
								<mat-tab *ngIf="IS_PROJECTS_ENABLED && showProjectsTab">
									<ng-template matTabLabel>
										<span>Projects</span>
										<span
											[matBadge]="totalNumberOfProjects"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										></span>
									</ng-template>

									<div class="full-width projects-tab">
										<app-projects-tab-content
											(loadMoreProjects)="loadMoreProjects.emit()"
											(projectAdded)="projectAdded($event)"
											[carrierProjectMap]="carrierProjectMap"
											[isLoadingProjectsList]="isLoadingProjectsList"
											[lanePricing]="lanePricing"
											[openedMatch]="openedMatch"
											[projectsNextPage]="projectsNextPage"
											[projectsViewList]="projectsViewList"
											[truckSearchResult]="true"
										></app-projects-tab-content>
									</div>
								</mat-tab>
								<mat-tab>
									<ng-template matTabLabel>
										<span>Notes</span>
										<span
											[matBadge]="totalNumberOfNotes"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										></span>
									</ng-template>
									<div style="overflow-y: scroll; max-height: 100vh">
										<app-note-list
											(noteCountUpdated)="totalNumberOfNotes = $event"
											[name]="carrierLaneData.lane.businessName"
											[id]="carrierLaneData.lane.carrierId"
											[showFeedback]="false"
											[manualNoteCount]="false"
											[origin]="IS_NOT_NULL_OR_UNDEFINED(selectedLane) ? selectedLane.origin : null"
											[destination]="
												IS_NOT_NULL_OR_UNDEFINED(selectedLane) ? selectedLane.destination : null
											"
											[truckLaneId]="
												IS_NOT_NULL_OR_UNDEFINED(selectedLane) ? selectedLane.laneId : null
											"
										></app-note-list>
									</div>
								</mat-tab>

								<mat-tab *ngIf="IS_TASKS_ENABLED">
									<ng-template matTabLabel>
										<span>Tasks</span>
										<span
											[matBadge]="totalNumberOfTasks"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										></span>
									</ng-template>
									<div
										*ngIf="IS_NOT_NULL_OR_UNDEFINED(carrierData.id)"
										class="ml-12"
										fxLayout="row"
									>
										<app-tasks-infinite-scroll
											(totalNumberOfTasks)="totalNumberOfTasks = $event"
											[carrier]="carrierData"
											[userAssignedToCarrier]="userAssignedToCarrier"
											fxFlex="100"
										></app-tasks-infinite-scroll>
									</div>
								</mat-tab>
							</mat-tab-group>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
